module.exports = __webpack_public_path__ + "static/media/day19.workshop.0a835b98.md";